export default {
  namespaced: true,
  state: {
    isShowWinTagClose: false
  },
  mutations: {
    // 开启多个标签，弹窗关闭旧的标签，保留最新的
    setIsShowWinTagClose(state, payload) {
      state.isShowWinTagClose = payload;
    }
  }
};
